import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppRoutes from './app/AppRoutes';
import ScrollToTop from './components/ScrollToTop';
import Footer from './Footter/Footer';
import Navbars from './NaveBare/Navbars';
import FavoritesProvider from './context/FavoritesProvider';
import './App.css';

export default function App() {
  const { i18n } = useTranslation();
  const skipLabel = i18n.language === 'ar' ? 'انتقل إلى المحتوى' : 'Skip to content';
  return (
    <BrowserRouter>
      <FavoritesProvider>
        <div className="App">
          <a href="#main-content" className="skip-link">{skipLabel}</a>
          <ScrollToTop />
          <Navbars />
          <main id="main-content" className="site-main" tabIndex="-1"><AppRoutes /></main>
          <Footer />
        </div>
      </FavoritesProvider>
    </BrowserRouter>
  );
}
